import React, {Fragment} from 'react';
import {arrayOf, shape, string, number, bool, object} from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Statistic, Table, Label, Container, Icon} from 'semantic-ui-react';
import isEmpty from 'lodash/isEmpty';
import {formatDate} from 'utils/DBUtils';
import FailureDisplay from './FailureDisplay';

const UserChallengesPage = props => {
  if (props.isLoading) {
    return (
      <Container textAlign='center'>
        <Icon loading name='spinner' size='huge' />
      </Container>
    );
  }

  if (props.ajaxError) {
    return <FailureDisplay labelKey='userManagement.userDetail.panes.challenges.ajaxError' />;
  }

  return !isEmpty(props.startsCompletes) && (
    <Fragment>
      <Statistic.Group widths={4}>
        <Container textAlign='center'>
          <Statistic>
            <Statistic.Value>{props.startsCompletes.totalStarts || 0}</Statistic.Value>
            <Statistic.Label>
              <FormattedMessage id='userManagement.userDetail.panes.challenges.totalStarts' />
            </Statistic.Label>
          </Statistic>
          <Statistic>
            <Statistic.Value>{props.startsCompletes.totalCompletes || 0}</Statistic.Value>
            <Statistic.Label>
              <FormattedMessage id='userManagement.userDetail.panes.challenges.totalCompletes' />
            </Statistic.Label>
          </Statistic>
          <Statistic>
            <Statistic.Value>{props.startsCompletes.totalWon || 0}</Statistic.Value>
            <Statistic.Label>
              <FormattedMessage id='userManagement.userDetail.panes.challenges.totalWon' />
            </Statistic.Label>
          </Statistic>
        </Container>
      </Statistic.Group>
      {props.startsCompletes.totalStarts !== 0 && (
        <Table striped>
          <Table.Header className='white-header'>
            <Table.HeaderCell>
              <FormattedMessage id='userManagement.userDetail.panes.challenges.cid' />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id='userManagement.userDetail.panes.challenges.title' />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id='userManagement.userDetail.panes.challenges.dateStarted' />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id='userManagement.userDetail.panes.challenges.dateCompleted' />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id='userManagement.userDetail.panes.challenges.status' />
            </Table.HeaderCell>
          </Table.Header>
          <Table.Body>
            {props.startsCompletes.actions.map(action => (
              <Table.Row>
                <Table.Cell>{action.cid}</Table.Cell>
                <Table.Cell>{action.title}</Table.Cell>
                <Table.Cell>{action.dateStarted ? formatDate(action.dateStarted) : ''}</Table.Cell>
                <Table.Cell>{action.dateCompleted ? formatDate(action.dateCompleted) : ''}</Table.Cell>
                <Table.Cell>
                  {action.winner ? (
                    <Label className='db-label-success'>
                      <FormattedMessage id='userManagement.userDetail.panes.challenges.status.winner' />
                    </Label>
                  ) : !action.dateCompleted ? (
                    <Label className='db-label-warning'>
                      <FormattedMessage id='userManagement.userDetail.panes.challenges.status.incomplete' />
                    </Label>
                  ) : null}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
    </Fragment>
  );
};

export const StartsCompletesPropType = {
  actions: arrayOf(shape({
    cid: string.isRequired,
    dateStarted: number.isRequired,
    dateCompleted: number,
    title: string.isRequired,
    winner: bool
  })),
  totalCompletes: number.isRequired,
  totalStarts: number.isRequired,
  totalWon: number.isRequired,
  uid: number.isRequired
};

UserChallengesPage.propTypes = {
  startsCompletes: StartsCompletesPropType,
  isLoading: bool.isRequired,
  ajaxError: object
};

export default UserChallengesPage;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/tabPanes/UserChallengesPage.jsx